/*
 * Storage for all Customers
 * Customer List
 */

import { createSlice, configureStore, current } from '@reduxjs/toolkit';

const viewSlice = createSlice({
    name: 'view',
    initialState: {
        viewData: {
            ID: null,
            Meta: {},
            Data: [],
            CustomElements: [],
            AddElements: [],
            DetailElements: [],
            TableElements: [],
            DashboardElements: [],
            Filter: {},
            Settings: {},
            data: [],
            Elements: [],
            ViewLabel: '',
            ViewType: '',
        },
    },
    reducers: {
        init(state, action) {
            //sets initial Data
            state.viewData = action.payload;
        },
        //#region Tables
        changeData(state, action) {
            console.log(action.payload);
            console.log('Change Data');
            let arrayVar = action.payload.key.split('-');
            let newVal = action.payload.newValue;
            if (arrayVar[0] === 'Data') {
                arrayVar.shift();
            }
            let elementtype = action.payload.isStatic ? action.payload.elementtype : action.payload.elementtype === 'checkbox' ? 'checkbox' : action.payload.elementtype === 'currency' ? 'currency' : action.payload.elementtype === 'download' ? 'download' : 'tabletext';
            if (!newVal) delete delete state.viewData.TableElements[0][Object.entries(state.viewData.TableElements[0]).find(d => d[1].Key === action.payload.key)[0]];
            else
                state.viewData.TableElements[0][action.payload.key] = {
                    Key: action.payload.key,
                    Name: action.payload.label,
                    Label: action.payload.label,
                    Sortable: true,
                    Order: 200,
                    Elementtype: elementtype,
                    DropdownName: action.payload.dropdownName,
                    Type: action.payload.type ?? 'text',
                    ReadOnly: action.payload.readOnly ?? false,
                };
            fillOrder(state.viewData.TableElements[0]);
        },
        changeTableHead(state, action) {
            // maybe switch this to settings instead of tableElement
            if (action.payload.prevTarget !== '') state.viewData.TableElements[0][action.payload.prevTarget][action.payload.property] = false;
            if (state.viewData.TableElements[0][action.payload.target]) state.viewData.TableElements[0][action.payload.target][action.payload.property] = true;
        },
        changeDefaultSettings(state, action) {
            if (!state.viewData.Settings) {
                state.viewData.Settings = {};
            }
            state.viewData.Settings[action.payload.target] = action.payload.newValue;
        },
        changeSortDescending(state, action) {
            // maybe switch this to settings instead of tableElement
            state.viewData.TableElements[0][action.payload.target]['SortDescending'] = !state.viewData.TableElements[0][action.payload.target]['SortDescending'];
        },
        changeValue(state, action) {
            Object.entries(state.viewData.TableElements[0]).find(e => e[1].Key === action.payload.key)[1][action.payload.target] = action.payload.newValue;
        },
        switchOrder(state, action) {
            console.log(action.payload);
            const newOrder = state.viewData.TableElements[0][action.payload.target].Order;
            state.viewData.TableElements[0][action.payload.shadow].Order = newOrder + (action.payload.insertBefore ? -0.5 : 0.5);
            fillOrder(state.viewData.TableElements[0]);
        },
        setSetting(state, action) {
            state.viewData[action.payload.key] = action.payload.value;
        },

        //#endregion Tables
        //#region Elements
        addElement(state, action) {
            state.viewData.CustomElements[action.payload.dataId].Data[action.payload.elId] = [...state.viewData.CustomElements[action.payload.dataId].Data[action.payload.elId], action.payload.newEl];
        },
        selectElement(state, action) {
            var index = getSelectedKeys(state.viewData.CustomElements).findIndex(el => el === action.payload.key);
            if (index === -1) {
                var newElement = { Elementtype: 'input', Type: action.payload.designData.Type, DefaultValue: '', Label: action.payload.designData.Label, Key: action.payload.key };
                state.viewData.CustomElements[0].Data[0] = [...state.viewData.CustomElements[0].Data[0], newElement];
            } else {
                var x = state.viewData.CustomElements.map(grp => {
                    return {
                        ...grp,
                        Data: grp?.Data.map(col => {
                            return col.filter(row => {
                                if (row.Key === action.payload.key) {
                                    return false;
                                }
                                return true;
                            });
                        }),
                    };
                });
                state.viewData.CustomElements = x;
            }
        },
        removeElement(state, action) {
            state.viewData.CustomElements[action.payload.groupKey].Data[action.payload.colKey].splice(action.payload.rowKey, 1);
        },
        changeElement(state, action) {
            let groupkey = action.payload.key.groupKey ?? 0;
            let rowkey = action.payload.key.rowKey ?? 0;

            state.viewData.CustomElements[groupkey].Data[action.payload.key.colKey][rowkey][action.payload.target] = action.payload.value;
            if (state.viewData.CustomElements[groupkey].Data[action.payload.key.colKey][rowkey]?.Key) {
                if (state.viewData.CustomElements[groupkey].Data[action.payload.key.colKey][rowkey]?.Elementtype === 'dropdown' || (action.payload.target === 'Elementtype' && action.payload.value === 'dropdown')) {
                    var data = getDataFromKey(state.viewData.Data[0], state.viewData.CustomElements[groupkey].Data[action.payload.key.colKey][rowkey]?.Key);
                    state.viewData.CustomElements[groupkey].Data[action.payload.key.colKey][rowkey].DropdownName = data?.DropdownName ?? '';
                }
                if (action.payload.target === 'Elementtype' && action.payload.value === 'profiling') {
                    var data = getDataFromKey(state.viewData.Data[0], state.viewData.CustomElements[groupkey].Data[action.payload.key.colKey][rowkey]?.Key);
                    state.viewData.CustomElements[groupkey].Data[action.payload.key.colKey][rowkey].ProfType = data?.ProfType ?? '';
                    state.viewData.CustomElements[groupkey].Data[action.payload.key.colKey][rowkey].Label = data?.Label ?? '';
                }
            }
        },
        switchElements(state, action) {
            if (action.payload.shadow === action.payload.target) return;
            if (action.payload.shadow.colKey === null || action.payload.shadow.colKey === undefined) {
                switchElementGroup(state, action);
            } else {
                const add = action.payload.target.rowKey > action.payload.shadow.rowKey && action.payload.shadow.colKey === action.payload.target.colKey ? (action.payload.insertBefore ? -1 : 0) : action.payload.insertBefore ? 0 : 1;
                state.viewData.CustomElements[action.payload.target.groupKey].Data[action.payload.target.colKey].splice(
                    +action.payload.target.rowKey + add,
                    0,
                    state.viewData.CustomElements[action.payload.shadow.groupKey].Data[action.payload.shadow.colKey].splice(action.payload.shadow.rowKey, 1)[0]
                );
            }
        },
        //#endregion Elements
        //#region ElementGroups
        changeElementGroup(state, action) {
            if (action.payload.target === 'Groupcol') {
                let cols = 12 / action.payload.value;
                while (state.viewData.CustomElements[action.payload.key.groupKey].Data.length !== cols) {
                    if (state.viewData.CustomElements[action.payload.key.groupKey].Data.length < cols) {
                        state.viewData.CustomElements[action.payload.key.groupKey].Data.push([]);
                    } else if (state.viewData.CustomElements[action.payload.key.groupKey].Data.length > cols) {
                        state.viewData.CustomElements[action.payload.key.groupKey].Data.pop();
                    }
                }
            }
            state.viewData.CustomElements[action.payload.key.groupKey][action.payload.target] = action.payload.value;
        },
        addElementGroup(state) {
            if (!state.viewData?.CustomElements) {
                state.viewData.CustomElements = [];
            }
            state.viewData.CustomElements.push({ Elementtype: 'elementgroup', Grouptype: 'text', Groupcol: 12, Data: [[]] });
        },
        removeElementGroup(state, action) {
            state.viewData.CustomElements.splice(action.payload, 1);
        },
        //#endregion ElementGroup
        //#region Filters

        addFilter(state, action) {
            var target;
            console.log(current(state.viewData));
            if (!getFilter(state.viewData, action.payload.filterType)) {
                console.log('Add Filter');
                if (action.payload.filterType === 'Filter') {
                    state.viewData.Filter = { Data: [] };
                }
            }
            target = getFilter(state.viewData, action.payload.filterType);
            if (target) target.Data.push({ Type: 'bool', Label: '' });
        },
        addPreMadeFilter(state, action) {
            if (state.viewData.PreMadeFilters) {
                state.viewData.PreMadeFilters.push({ Name: action.payload.name, Data: [] });
            } else {
                state.viewData.PreMadeFilters = [{ Name: action.payload.name, Data: [] }];
            }
        },

        removePreMadeFilter(state, action) {
            if(action.payload.filter >= 0){
                state.viewData.PreMadeFilters.splice(action.payload.filter, 1);
            }
        },

        removeFilter(state, action) {
            var target = getFilter(state.viewData, action.payload.filterType);
            if (target) target.Data.splice(action.payload.idx, 1);
        },
        changeFilter(state, action) {
            var target = getFilter(state.viewData, action.payload.filterType);
            if (target) target.Data[action.payload.idx][action.payload.target] = action.payload.newValue;

            if (action.payload.target === 'Key') {
                var data = getDataFromKey(state.viewData.Data[0], action.payload.newValue);

                if (action.payload.newValue === 'Onlycustomer') data = { Elementtype: 'checkbox', Type: '' };
                target = getFilter(state.viewData, action.payload.filterType);
                if (target) target.Data[action.payload.idx]['SpecialFilter'] = data.SpecialFilter;
                target = getFilter(state.viewData, action.payload.filterType);
                if (target) target.Data[action.payload.idx]['FilterName'] = data.FilterName;
                if (data.Elementtype === 'input') {
                    switch (data.Type) {
                        case 'date':
                        case 'datetime-local':
                            target = getFilter(state.viewData, action.payload.filterType);
                            if (target) target.Data[action.payload.idx]['Type'] = 'date';
                            break;
                        case 'text':
                            target = getFilter(state.viewData, action.payload.filterType);
                            if (target) target.Data[action.payload.idx]['Type'] = 'text';
                            break;
                        case 'number':
                            target = getFilter(state.viewData, action.payload.filterType);
                            if (target) target.Data[action.payload.idx]['Type'] = 'number';
                            break;
                        default:
                            break;
                    }
                } else if (data.Elementtype === 'checkbox') {
                    target = getFilter(state.viewData, action.payload.filterType);
                    if (target) target.Data[action.payload.idx]['Type'] = 'bool';
                } else if (data.Elementtype === 'checkboxnon') {
                    target = getFilter(state.viewData, action.payload.filterType);
                    if (target) target.Data[action.payload.idx]['Type'] = 'boolnon';
                } else if (data.Elementtype === 'dropdown') {
                    target = getFilter(state.viewData, action.payload.filterType);
                    if (target) target.Data[action.payload.idx]['Type'] = 'dropdown';
                    target = getFilter(state.viewData, action.payload.filterType);
                    if (target) target.Data[action.payload.idx]['DropdownName'] = data.DropdownName ?? '';
                }
                target = getFilter(state.viewData, action.payload.filterType);
                if (target) target.Data[action.payload.idx]['Label'] = data.Label ?? data.Name ?? '';
                console.log(current(state.viewData));
            }
        },
        changeProfCritFilter(state, action) {
            var target = getFilter(state.viewData, action.payload.filterType);

            if (target) target.Data[action.payload.idx][action.payload.target] = action.payload.newValue;
            if (action.payload.target === 'Key') {
                console.log(action.payload);
                var profCrit = action.payload.profCrit.find(d => d.Criteria === action.payload.newValue) ?? { Elementtype: 'input', Type: 'text', Label: '', Key: action.payload.newValue, Criteria: action.payload.newValue, SpecialFilter: false, FilterName: '' };
                console.log(profCrit);
                console.log(current(target));
                const baseKey = action.payload.newValue;

                // Filter all target items with the same Criteria
                const existing = target.Data.filter(item => item.Criteria === profCrit.Criteria);

                // Extract all numeric suffixes from existing keys that start with the baseKey
                let maxSuffix = 0;

                existing.forEach(item => {
                    const regex = new RegExp(`^${baseKey}(?:[_]?)(\\d+)?$`);
                    const match = item.Key.match(regex);
                    if (match) {
                        const num = match[1] ? parseInt(match[1], 10) : 1;
                        if (!isNaN(num)) {
                            maxSuffix = Math.max(maxSuffix, num);
                        }
                    }
                });

                // If a match exists, increment suffix
                if (existing.length > 0) {
                    const nextSuffix = maxSuffix + 1;
                    profCrit.Key = `${baseKey}_${nextSuffix}`;
                }else {
                    profCrit.Key = baseKey;
                }
                target.Data[action.payload.idx]['Key'] = profCrit.Key;
                target.Data[action.payload.idx]['Criteria'] = profCrit.Criteria;
                target.Data[action.payload.idx]['Label'] = profCrit.Name ?? profCrit.Criteria ?? '';
                target.Data[action.payload.idx]['ProfCrit'] = true;
                switch (profCrit.Type) {
                    case 0:
                        target.Data[action.payload.idx]['Type'] = 'text';
                        break;
                    case 1:
                        target.Data[action.payload.idx]['Type'] = 'number';
                        break;
                    case 2:
                        target.Data[action.payload.idx]['Type'] = 'date';
                        break;
                    case 3:
                        target.Data[action.payload.idx]['Type'] = 'bool';
                        break;
                    case 4:
                        target.Data[action.payload.idx]['Type'] = 'number';
                        break;
                    case 5:
                        target.Data[action.payload.idx]['Type'] = 'datetime-local';
                        break;
                    default:
                        target.Data[action.payload.idx]['Type'] = 'text';
                        break;
                }
                if (profCrit.Conformity) {
                    target.Data[action.payload.idx]['Type'] = 'dropdown';
                    target.Data[action.payload.idx]['DropdownName'] = profCrit.Criteria;
                }
            }
            console.log(current(state.viewData));
            console.log(current(target));
        },
        switchFilterOrder(state, action) {
            const add = action.payload.target > action.payload.shadow ? (action.payload.insertBefore ? -1 : 0) : action.payload.target < action.payload.shadow ? (action.payload.insertBefore ? 0 : 1) : 0;
            state.viewData?.[action.payload.filterType].Data.splice(+action.payload.target + add, 0, state.viewData?.[action.payload.filterType].Data.splice(action.payload.shadow, 1)[0]);
        },
        //#endregion Filters
        //#region Dashboard
        changeDashboard(state, action) {
            state.viewData.DashboardElements[action.payload.idx][action.payload.target] = action.payload.newValue;
        },
        changeDashboardUpdateTimer(state, action) {
            state.viewData.DashboardElements[0].UpdateTime = action.payload.newValue;
        },
        addDashboard(state, action) {
            state.viewData.DashboardElements.push({ Name: action.payload, Type: 'base', Headline: '', 'SQL-Data': '' });
        },
        removeDashboard(state, action) {
            state.viewData.DashboardElements.splice(action.payload, 1);
        },
        //#endregion Dashboard
        removeUnnecessaryData(state, action) {
            console.log(current(state.viewData));
            const keys = Object.entries(state.viewData.TableElements[0]).map(e => {
                return e[1].Key;
            });
            const nData = getAllNecessaryData(state.viewData.Data[0], keys);
            state.viewData.Data[0] = nData;
            console.log(current(state.viewData));
        },
    },
});

function fillOrder(table) {
    let previous = 0;
    Object.entries(table)
        .sort((a, b) => {
            return a[1].Order > b[1].Order ? 1 : -1;
        })
        .forEach((attributes, idx) => {
            if (idx === 0) attributes[1].Order = 1;
            else attributes[1].Order = previous + 1;
            previous = attributes[1].Order;
        });
}

function getSelectedKeys(elements) {
    let keys = [];
    elements.forEach(grp => {
        return {
            ...grp,
            Data: grp?.Data.forEach(col => {
                return col.forEach(row => {
                    if (row.Key) {
                        keys.push(row.Key);
                    }
                });
            }),
        };
    });
    console.log(keys);
    return keys;
}

function getAllNecessaryData(data, keys) {
    let x = {};
    Object.entries(data).forEach((attributes, idxObj) => {
        if (typeof attributes[1] === 'object') {
            if (keys.includes(attributes[1].Key)) {
                x = { ...x, [attributes[0]]: attributes[1] };
            } else x = { ...x, ...getAllNecessaryData(attributes[1], keys) };
        }
    });
    return x;
}

function getDataFromKey(data, target) {
    var x = null;
    Object.entries(data).forEach(key => {
        if (typeof key[1] === 'object' && (key[1].Designable === true || key[1].SpecialFilter === true) && (key[1].Label || key[1].Name)) {
            if (target === key[1].Key) {
                x = key[1];
            }
        } else if ((Array.isArray(key[1]) || typeof key[1] === 'object') && !key[1].Designable && key[1].Designable !== false) {
            x = getDataFromKey(key[1], target) ?? x;
        }
    });
    return x;
}

function switchElementGroup(state, action) {
    var x = state.viewData.CustomElements[action.payload.shadow.groupKey];
    state.viewData.CustomElements[action.payload.shadow.groupKey] = state.viewData.CustomElements[action.payload.target.groupKey];
    state.viewData.CustomElements[action.payload.target.groupKey] = x;
    console.log(current(state.viewData.CustomElements));
}
function getFilter(value, filterType) {
    var val = filterType.includes('.') ? value?.[filterType?.split('.')?.[0]]?.[filterType?.split('.')?.[1]] : value?.Filter;
    return val;
}
const store = configureStore({
    reducer: viewSlice.reducer,
});
export const viewActions = viewSlice.actions;
export default store;
